define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi",
	"csi/reflection",
	"csi/session",
	"csi/view/ToolbarPluginSwitchboard"
], function(declare,domClass,csi,reflection,session,ToolbarPluginSwitchboard) {

	return declare(ToolbarPluginSwitchboard, {
		postCreate: function() {
			// summary: display the "Go" button
			this.inherited(arguments);
			domClass.remove(this.goNode.domNode, "nodisplay");
		},

        _getStoreOptions: function(/*String*/url, /*csi.def.Relationship?*/r) {
             // summary: switchboard dropdown display parent's BusinessPlan node name
             var options = this.inherited(arguments);
             options.request.addParameter("Qry.Value.Path", reflection.PATH_PARENT);
             return options;
        },

		_onGo: function(/*Event*/e) {
			// summary: navigate to parent BusinessPlan node of currently selected item
			var selectedNode = this.actionToolbar.view.cacheView.getNode(this.get("value"), true);
			var businessPlan = selectedNode.__Parent__;
			session.setLocationUrl(businessPlan);
		}
	});
});